<template>
	<div
		class="card"
		:class="{
			'card--bonus-words': isBonusWords,
		}"
		:style="{ borderTopColor: color }"
	>
		<h2 class="title" v-html="title" />
		<ul class="list" :class="{ 'list--2-columns': isDoubleColumn }">
			<li v-for="(word, index) in visibleWords" :key="index">
				{{ word.toLowerCase() }}
			</li>
		</ul>
		<p v-if="showLoginButton" class="login-message">
			See all {{ words.length }} bonus words?
		</p>
		<button
			v-if="showLoginButton"
			class="login-button"
			aria-label="Sign Up For Free"
			@click="onLoginButtonClick"
		>
			Sign up for free
		</button>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { BONUS_WORDS } from "@/common/consts";
export default {
	name: "BoardCard",
	props: {
		title: {
			type: String,
			required: true,
		},
		color: {
			type: String,
			required: false,
			default: null,
		},
		words: {
			type: Array,
			required: true,
		},
		isBonusWords: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		...mapState({
			loggedIn: (state) => state.login.loggedIn,
		}),
		isDoubleColumn() {
			return this.visibleWords.length > BONUS_WORDS.SINGLE_COLUMN_MAX;
		},
		visibleWords() {
			if (!this.isBonusWords || this.loggedIn) return this.words;
			return this.words.slice(0, BONUS_WORDS.GUEST_MAX);
		},
		showLoginButton() {
			return (
				this.isBonusWords &&
				!this.loggedIn &&
				this.words.length > BONUS_WORDS.GUEST_MAX
			);
		},
	},
	methods: {
		async getFirebaseClient() {
			const firebase = await import("firebase/app");
			await import("firebase/auth");
			let firebaseConfig = await import("@/firebaseConfig");

			if (!firebase.apps.length) {
				firebase.initializeApp(firebaseConfig.default);
			}

			return firebase;
		},
		onLoginButtonClick() {
			this.$store.commit("SET_LOG_IN_ERROR", null);
			if (typeof window.__PRERENDER_INJECTED === "undefined") {
				this.getFirebaseClient()
					.then((firebase) => {
						firebase.auth().onAuthStateChanged((user) => {
							this.$store.dispatch("fetchUser", user);
						});
					})
					.catch(console.log);
				this.$store.commit("SET_DIALOG_STATE", true);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/media-queries";
.card {
	background-color: #fff;
	border-top: 4px solid #bf45f3;
	box-shadow: -10px 10px 20px 0 rgba(124, 147, 173, 0.1);
	margin-bottom: 20px;
	padding: 20px 20px 16px;
	padding-bottom: 16px;

	@include from-medium-device {
		margin-bottom: 30px;
		padding: 25px;

		&:last-of-type {
			margin-bottom: 12px;
		}
	}
}

.title {
	color: #282d32;
	font-size: 15px;
	font-weight: 500;
	line-height: 14px;
	text-transform: uppercase;
}

.title ::v-deep span {
	display: block;

	&:last-child {
		color: #7c93ad;
		font-size: 13px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 30px;
		text-transform: none;
	}
}

.list {
	display: block;
	margin: 0;
	&.list--2-columns {
		-webkit-columns: 2;
		-moz-columns: 2;
		columns: 2;
	}

	li {
		font-size: 15px;
		line-height: 28px;
	}
}

.login-message {
	color: rgb(40, 45, 50);
	font-size: 15px;
	font-weight: bold;
	margin: 1em 0 12px;
}

.login-button {
	background: rgb(21, 101, 192);
	border: 0;
	color: #fff;
	cursor: pointer;
	font-size: 14px;
	font-weight: bold;
	line-height: 28px;
	margin-bottom: 5px;
	padding: 4px 14px;
	text-align: center;
}
</style>
